import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, MutationAction, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app'
import WorkerDto from '@/models/Workers/WorkerDto';
import WorkerPositionDto from '@/models/WorkerPositions/WorkerPositionDto';
import WorkerSkillDto from '@/models/WorkerSkills/WorkerSkillDto';
import NoteDto from '@/models/Notes/NoteDto';
import WorkerQualificationDto from '@/models/WorkerQualifications/WorkerQualificationDto';
import UpdateWorkerProfileDetailsRequest from '@/models/Workers/UpdateWorkerProfileDetailsRequest';
import UpdateWorkerGeneralDetailsRequest from '@/models/Workers/UpdateWorkerGeneralDetailsRequest';
import AgencyAttributesDto from '@/models/Agencies/AgencyAttributesDto';
import CreateWorkerPositionRequest from '@/models/WorkerPositions/CreateWorkerPositionRequest';
import CreateWorkerSkillRequest from '@/models/WorkerSkills/CreateWorkerSkillRequest';
import CreateWorkerQualificationRequest from '@/models/WorkerQualifications/CreateWorkerQualificationRequest';
import UpdateWorkerPositionRequest from '@/models/WorkerPositions/UpdateWorkerPositionRequest';
import UpdateWorkerSkillRequest from '@/models/WorkerSkills/UpdateWorkerSkillRequest';
import UpdateWorkerQualificationRequest from '@/models/WorkerQualifications/UpdateWorkerQualificationRequest';
import CreateNoteRequest from '@/models/Notes/CreateNoteRequest';
import DocumentDto from '@/models/Documents/DocumentDto';
import UploadDocumentRequest from '@/models/Documents/UploadDocumentRequest';
import UpdateDocumentRequest from '@/models/Documents/UpdateDocumentRequest';
import UpdateNoteRequest from '@/models/Notes/UpdateNoteRequest';
import CreateDocumentRequest from '@/models/Documents/CreateDocumentRequest';
import StorageUploadResponse from '@/models/Storage/StorageUploadResponse';
import FileUtils from '@/lib/fileUtils';
import UpdateAddressDetailsRequest from '@/models/Shared/UpdateAddressDetailsRequest';
import UpdateWorkerPayrollDetailsRequest from '@/models/Workers/UpdateWorkerPayrollDetailsRequest';
import UpdateWorkerTempTransportDetailsRequest from '@/models/Workers/UpdateWorkerTempTransportDetailsRequest';
import UpdateWorkerTempEmergencyDetailsRequest from '@/models/Workers/UpdateWorkerTempEmergencyDetailsRequest';
import TimesheetDto from '@/models/Timesheets/TimesheetDto';
import TimesheetStatus from '@/models/Timesheets/TimesheetStatus';
import UpdateWorkerStatusRequest from '@/models/Workers/UpdateWorkerStatusRequest';
import FileWithExpiry from '@/models/Documents/FileWithExpiry';
import UpdateWorkerAvailabilityDetailsRequest from '@/models/Workers/UpdateWorkerTempAvailabilityDetailsRequest';
import UpdateWorkerAvailabilityRestrictionRequest from '@/models/Workers/UpdateWorkerTempAvailabilityRestrictionRequest';
import UpdateWorkerConvictionDetailsRequest from '@/models/Workers/UpdateWorkerConvictionDetailsRequest';
import CreateAvailabilityRestrictionPeriodRequest from '@/models/AvailabilityRestrictionPeriods/CreateAvailabilityRestrictionPeriodRequest';
import AvailabilityRestrictionPeriodDto from '@/models/AvailabilityRestrictionPeriods/AvailabilityRestrictionPeriodDto';
import AgencyWorkerRightsCalendar from '@/models/AgencyWorkerRights/AgencyWorkerRightsCalendar';
import UpdateWorkerPermCurrentDetailsRequest from '@/models/Workers/UpdateWorkerPermCurrentDetailsRequest';
import UpdateWorkerPermDesiredDetailsRequest from '@/models/Workers/UpdateWorkerPermDesiredDetailsRequest';
import UpdateWorkerPermPreviousExperienceRequest from '@/models/Workers/UpdateWorkerPermPreviousExperienceRequest';
import ContactWorkerDto from '@/models/ContactWorkers/ContactWorkerDto';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import LocationWorkerDto from '@/models/LocationWorkers/LocationWorkerDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import LocationProfileSearchRequest from '@/models/Locations/LocationProfileSearchRequest';
import CreateLocationWorkerRequest from '@/models/LocationWorkers/CreateLocationWorkerRequest';
import UpdateLocationWorkerRequest from '@/models/LocationWorkers/UpdateLocationWorkerRequest';
import DeleteLocationWorkerRequest from '@/models/LocationWorkers/DeleteLocationWorkerRequest';
import SendTestPushNotificationRequest from '@/models/PushNotifications/SendTestPushNotificationRequest';
import UpdateAvatarViewModel from '@/models/Avatars/UpdateAvatarViewModel';
import UploadAvatarRequest from '@/models/Avatars/UploadAvatarRequest';
import UpdateAvatarRequest from '@/models/Avatars/UpdateAvatarRequest';
import NoteCategoryDto from '@/models/NoteCategories/NoteCategoryDto';
import UpdateWorkerEmailAddressUsernameRequest from '@/models/Workers/UpdateWorkerEmailAddressUsernameRequest';
import FilterConversationSearchViewModel from '@/models/Conversations/FilterConversationSearchViewModel';
import CurrentConversationSearchCriteria from '@/models/Conversations/CurrentConversationSearchCriteria';
import ConversationTopicFirestoreDto from '@/models/ConversationTopics/ConversationTopicFirestoreDto';
import ConversationDto from '@/models/Conversations/ConversationDto';
import BookingRoleWorkerDto from '@/models/BookingRoleWorkers/BookingRoleWorkerDto';
import MessageDto from '@/models/Messages/MessageDto';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import { addDoc, collection, collectionGroup, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import db from '@/firebase/init';
import EntityType from '@/models/Shared/EntityType';
import AssignConversationRequest from '@/models/Conversations/AssignConversationRequest';
import UpdateConversationStatusRequest from '@/models/Conversations/UpdateConversationStatusRequest';
import CreateConversationParticipantRequest from '@/models/Conversations/CreateConversationParticipantRequest';
import CreateConversationRequest from '@/models/Conversations/CreateConversationRequest';
import WorkerConversationsViewModel from '@/models/Conversations/WorkerConversationsViewModel';

export interface IWorkerDetailsState {
  loading: boolean; 
  agencyAttributes: AgencyAttributesDto;
  currentWorker: WorkerDto;
  availabilityRestrictionPeriods: AvailabilityRestrictionPeriodDto[];
  positions: WorkerPositionDto[];
  currentPosition: WorkerPositionDto;
  loadingPositions: boolean;
  skills: WorkerSkillDto[];
  currentSkill: WorkerSkillDto;
  loadingSkills: boolean;
  qualifications: WorkerQualificationDto[];
  currentQualification: WorkerQualificationDto;
  loadingQualifications: boolean;
  locationWorkers: LocationWorkerDto[];
  loadingLocationWorkers: boolean;
  locations: LocationProfileDto[];
  loadingLocations: boolean;
  notes: NoteDto[];
  noteCategories: NoteCategoryDto[];
  loadingNotes: boolean;
  documents: DocumentDto[];
  storageUploadResponse: StorageUploadResponse;
  loadingDocuments: boolean;
  shifts: TimesheetDto[];
  loadingShifts: boolean;
  contacts: ContactWorkerDto[];
  loadingContacts: boolean;
  jobs: JobWorkerDto[];
  loadingJobs: boolean;
  awrSummary: AgencyWorkerRightsCalendar[];
  loadingAwrSummary: boolean;
  loadingDialog: boolean;

  //Messaging related

  workerConversationsVM: WorkerConversationsViewModel;

  loadingConversations: boolean;
  loadingConversation: boolean;
  loadingWorkerProfile: boolean;
  loadingBookingRoleWorkerSummary: boolean;
  showNewConversationBanner: boolean;
  filterConversationSearchViewModel: FilterConversationSearchViewModel;
  currentConversationSearchCriteria: CurrentConversationSearchCriteria;
  conversationTopics: ConversationTopicFirestoreDto[];
  conversations: ConversationDto[];
  //selectedConversation: ConversationDto;
  //selectedConversationId: string;
  messages: MessageDto[];
  bookingRoleWorkerSummary: BookingRoleWorkerDto;
  unsubscribeToConversationTopics: any;
  unsubscribeToConversations: any;
  unsubscribeToMessages: any;
  conversationParticipants: ConversationParticipantDto[];
  unsubscribeToConversationParticipants: any;
  agencyUsers: AgencyUserDto[];
}

@Module({ dynamic: true, store, name: 'WorkerDetails', namespaced: true })
class WorkerDetails extends VuexModule implements IWorkerDetailsState {
 
  public loading = false;
  public agencyAttributes: AgencyAttributesDto = new AgencyAttributesDto();
  public currentWorker: WorkerDto = new WorkerDto();
  public availabilityRestrictionPeriods: AvailabilityRestrictionPeriodDto[] = [];
  public positions: WorkerPositionDto[] = [];
  public currentPosition: WorkerPositionDto = new WorkerPositionDto();
  public loadingPositions = true;
  public skills: WorkerSkillDto[] = [];
  public currentSkill: WorkerSkillDto = new WorkerSkillDto();
  public loadingSkills = true;
  public qualifications: WorkerQualificationDto[] = [];
  public currentQualification: WorkerQualificationDto = new WorkerQualificationDto();
  public loadingQualifications = true;
  public locationWorkers: LocationWorkerDto[] = [];
  public loadingLocationWorkers = true;
  public locations: LocationProfileDto[] = [];
  public loadingLocations = true;
  public notes: NoteDto[] = [];
  public noteCategories: NoteCategoryDto[] = [];
  public loadingNotes = true;
  public documents: DocumentDto[] = [];
  public storageUploadResponse: StorageUploadResponse = null;
  public loadingDocuments = true;
  public shifts: TimesheetDto[] = [];
  public loadingShifts = true;
  public contacts: ContactWorkerDto[] = [];
  public loadingContacts = true;
  public jobs: JobWorkerDto[] = [];
  public loadingJobs = true;
  public awrSummary: AgencyWorkerRightsCalendar[] = [];
  public loadingAwrSummary = true;
  public loadingDialog = false;

  //Messaging related

  public workerConversationsVM: WorkerConversationsViewModel = new WorkerConversationsViewModel();
  public loadingConversations = true;
  public loadingConversation = true;
  public loadingWorkerProfile = true;
  public loadingBookingRoleWorkerSummary = true;
  public showNewConversationBanner = false;
  public filterConversationSearchViewModel: FilterConversationSearchViewModel = new FilterConversationSearchViewModel();
  public currentConversationSearchCriteria: CurrentConversationSearchCriteria = new CurrentConversationSearchCriteria();
  public conversationTopics: ConversationTopicFirestoreDto[] = [];
  public conversations: ConversationDto[] = [];
  //public selectedConversation: ConversationDto = null;
  //public selectedConversationId: string = '';
  public messages: MessageDto[] = [];
  public bookingRoleWorkerSummary: BookingRoleWorkerDto = null;
  public unsubscribeToConversationTopics: any = null;
  public unsubscribeToConversations: any = null;
  public unsubscribeToMessages: any = null;
  public conversationParticipants: ConversationParticipantDto[] = [];
  public unsubscribeToConversationParticipants: any = null;
  public agencyUsers: AgencyUserDto[] = [];
  

  @Action
  public async getAgencyAttributes() {
    this.setLoading(true);
    await ajax.get(`/api/v1/agency/attributes`)
    .then(response => {
      this.context.commit("setAgencyAttributes", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  public async getWorker(worker: WorkerDto) {
    this.setLoading(true);
    await ajax.get(`/api/v1/agency/workers/${worker.id}`)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async editProfileDetails(worker: WorkerDto) {
    this.setLoadingDialog(true);
    const request = new UpdateWorkerProfileDetailsRequest();
    request.updatedAt = worker.updatedAt;
    request.title = worker.title;
    request.firstName = worker.person.firstName;
    request.lastName = worker.person.lastName;
    request.summary = worker.summary;

    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/profile-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editWorkerAvatar(vm: UpdateAvatarViewModel) {
    this.setLoadingDialog(true);
     //First get the signed URL
    const uploadRequest = new UploadAvatarRequest();
    uploadRequest.originFileName = vm.originFileName;
    uploadRequest.contentType = vm.contentType;
    let destinationFileName = '';
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/avatar/upload`, uploadRequest)
    .then(async uploadResponse => {
      const config = {
        headers: {
          'content-type': vm.contentType,
        }
      };
      destinationFileName = uploadResponse.data.destinationFileName;
      return ajax.put(uploadResponse.data.signedUrl, vm.blobToUpload, config)})
      .then(googleResponse => {
        const updateRequest = new UpdateAvatarRequest();
        updateRequest.fileName = destinationFileName;
        ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/avatar`, updateRequest)
        .then(response => {
          this.context.commit("setCurrentWorker", response.data);
          this.setLoadingDialog(false);
        })
        .catch(error => {
          AppModule.handleApiError(error);
          this.setLoadingDialog(false);
        })
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingDialog(false);
      })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editGeneralDetails(request: UpdateWorkerGeneralDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/general-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editEmailAddressUsername(request: UpdateWorkerEmailAddressUsernameRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/email-address-username`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async editAddressDetails(request: UpdateAddressDetailsRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/address-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  // Pulls the payroll-system-mastered statutory fields (NI number + UK tax
  // data) back onto the worker record — the refresh button on the Payroll
  // Details panel for synced workers.
  @Action
  async refreshPayrollDetails() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/payroll-details/refresh`, {})
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async refreshHoliday() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/holiday/refresh`, {})
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editPayrollDetails(request: UpdateWorkerPayrollDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/payroll-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editTempTransportDetails(request: UpdateWorkerTempTransportDetailsRequest) {
    this.setLoadingDialog(true);
      await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/temp/transport-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editTempEmergencyDetails(request: UpdateWorkerTempEmergencyDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/temp/emergency-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editAvailabilityDetails(worker: WorkerDto) {
    this.setLoadingDialog(true);
    const request = new UpdateWorkerAvailabilityDetailsRequest();
    request.updatedAt = worker.updatedAt;
    request.availability = worker.availability;

    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/temp/availability-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editAvailabilityRestriction(request: UpdateWorkerAvailabilityRestrictionRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/temp/availability-restriction`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async inviteUser() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/invite`)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async resendEmailVerification() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/resend-email-verification`)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async resetEmailVerification() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/reset-email-verification`)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async resetInvite() {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/reset-invite`)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async sendTestPushNotification(request: SendTestPushNotificationRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/test-push-notification`, request)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action 
  async createAvailabilityRestrictionPeriod(request: CreateAvailabilityRestrictionPeriodRequest) {
    //this.setLoading(true);
    await ajax.post(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/temp/availability-restriction-periods`, request)
    .then(response => {
      this.context.commit("setAvailabilityRestrictionPeriodFromCreate", response.data);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action 
  async deleteAvailabilityRestrictionPeriod(availabilityRestrictionPeriod: AvailabilityRestrictionPeriodDto) {
    //this.setLoading(true);
    await ajax.delete(`/api/v1/agency/workers/${WorkerDetailsModule.currentWorker.id}/temp/availability-restriction-periods/${availabilityRestrictionPeriod.id}`)
    .then(response => {
      this.context.commit("removeAvailabilityRestrictionPeriodFromDelete", availabilityRestrictionPeriod);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action
  async getAwrSummary() {
    this.setLoadingAwrSummary(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/temp/agency-worker-rights`)
    .then(response => {
      this.context.commit("setAwrSummary", response.data);
      this.setLoadingAwrSummary(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingAwrSummary(false);
    });
  }

  @Action
  async editPermCurrentDetails(request: UpdateWorkerPermCurrentDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/perm/current-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editPermPreviousExperience(request: UpdateWorkerPermPreviousExperienceRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/perm/previous-experience`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editPermDesiredDetails(request: UpdateWorkerPermDesiredDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/perm/desired-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editConvictionDetails(request: UpdateWorkerConvictionDetailsRequest) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/conviction-details`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editStatus(worker: WorkerDto) {
    this.setLoadingDialog(true);
    const request = new UpdateWorkerStatusRequest();
    request.updatedAt = worker.updatedAt;
    request.status = worker.status;

    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/status`, request)
    .then(response => {
      this.context.commit("setCurrentWorker", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getPositions() {
    this.setLoadingPositions(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/positions`)
    .then(response => {
      this.context.commit("setPositions", response.data);
      this.setLoadingPositions(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingPositions(false);
    });
  }

  @Action
  async createPosition(request: CreateWorkerPositionRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/positions`, request)
    .then(response => {
      this.context.commit("setPositionFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }


  @Action
  async editPosition(workerPosition: WorkerPositionDto) {
    this.setLoadingDialog(true);
    const request = new UpdateWorkerPositionRequest();
    request.updatedAt = workerPosition.updatedAt;
    request.status = workerPosition.status;
    request.payRate = workerPosition.payRate;
    request.workTypes = workerPosition.workTypes
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/positions/${workerPosition.id}`, request)
    .then(response => {
      this.context.commit("setPositionFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async deletePosition(workerPositionId: string) {
    await ajax.delete(`/api/v1/agency/workers/${this.currentWorker.id}/positions/${workerPositionId}`)
    .then(() => {
      this.context.commit("removePosition", workerPositionId);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getSkills() {
    this.setLoadingSkills(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/skills`)
    .then(response => {
      this.context.commit("setSkills", response.data);
      this.setLoadingSkills(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingSkills(false);
    });
  }

  @Action
  async createSkill(request: CreateWorkerSkillRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/skills`, request)
    .then(response => {
      this.context.commit("setSkillFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editSkill(workerSkill: WorkerSkillDto) {
    this.setLoadingDialog(true);
    const request = new UpdateWorkerSkillRequest();
    request.updatedAt = workerSkill.updatedAt;
    request.status = workerSkill.status;
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/skills/${workerSkill.id}`, request)
    .then(response => {
      this.context.commit("setSkillFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async deleteSkill(workerSkillId: string) {
    await ajax.delete(`/api/v1/agency/workers/${this.currentWorker.id}/skills/${workerSkillId}`)
    .then(() => {
      this.context.commit("removeSkill", workerSkillId);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getQualifications() {
    this.setLoadingQualifications(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/qualifications`)
    .then(response => {
      this.context.commit("setQualifications", response.data);
      this.setLoadingQualifications(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingQualifications(false);
    });
  }

  @Action
  async createQualification(request: CreateWorkerQualificationRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/qualifications`, request)
    .then(response => {
      this.context.commit("setQualificationFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editQualification(workerQualification: WorkerQualificationDto) {
    this.setLoadingDialog(true);
    const request = new UpdateWorkerQualificationRequest();
    request.updatedAt = workerQualification.updatedAt;
    request.status = workerQualification.status;
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/qualifications/${workerQualification.id}`, request)
    .then(response => {
      this.context.commit("setQualificationFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async deleteQualification(workerQualificationId: string) {
    await ajax.delete(`/api/v1/agency/workers/${this.currentWorker.id}/qualifications/${workerQualificationId}`)
    .then(() => {
      this.context.commit("removeQualification", workerQualificationId);
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getLocationWorkers() {
    this.setLoadingLocationWorkers(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/locations`)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setLocationWorkers", response.data);
      this.setLoadingLocationWorkers(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingLocationWorkers(false);
    });
  }

  @Action
  public async createLocationWorker(request: CreateLocationWorkerRequest) {
    this.setLoadingDialog(true); 
    const locationId = request.locationId;
    request.locationId = undefined
    await ajax.post(`/api/v1/agency/locations/${locationId}/workers`, request)
    .then(response => {
      this.context.commit("setLocationWorkerFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async updateLocationWorker(request: UpdateLocationWorkerRequest){
    this.setLoadingDialog(true); 
    const locationWorkerId = request.locationWorkerId;
    const locationId = request.locationId;
    request.locationWorkerId = undefined;
    request.locationId = undefined;
    await ajax.put(`/api/v1/agency/locations/${locationId}/workers/${locationWorkerId}`, request)
    .then(response => {
      this.context.commit("setLocationWorkerFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async deleteLocationWorker(request: DeleteLocationWorkerRequest) {
    this.setLoadingDialog(true); 
    await ajax.delete(`/api/v1/agency/locations/${request.locationId}/workers/${request.locationWorkerId}`)
    .then(response => {
      this.context.commit("setLocationWorkerFromDelete", request.locationWorkerId);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  @Action
  public async getLocations() {
    const request = new LocationProfileSearchRequest();
    //request.statuses.push(LocationStatus.Active);
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/locations/search`, request)
    .then(response => {
      this.context.commit("setLocations", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getNoteCategories() {
    this.setLoadingNotes(true);
    await ajax.get(`/api/v1/agency/note-categories?entityType=3`)
    .then(response => {
      this.context.commit("setNoteCategories", response.data);
      this.setLoadingNotes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingNotes(false);
    });
  }

  @Action
  async getNotes() {
    this.setLoadingNotes(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/notes`)
    .then(response => {
      this.context.commit("setNotes", response.data);
      this.setLoadingNotes(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingNotes(false);
    });
  }

  @Action
  async createNote(request: CreateNoteRequest) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/notes`, request)
    .then(response => {
      this.context.commit("setNoteFromCreate", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async editNote(note: NoteDto) {
    const request = new UpdateNoteRequest();
    request.updatedAt = note.updatedAt
    request.description = note.description;
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/notes/${note.id}`, request)
    .then(response => {
      this.context.commit("setNoteFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getDocuments() {
    this.setLoadingDocuments(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/documents`)
    .then(response => {
      this.context.commit("setDocuments", response.data);
      this.setLoadingDocuments(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDocuments(false);
    });
  }

  @Action
  async getShifts() {
    this.setLoadingShifts(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/shifts`)
    .then(response => {
      this.context.commit("setShifts", response.data);
      this.setLoadingShifts(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingShifts(false);
    });
  }

  @Action
  async getContacts() {
    this.setLoadingContacts(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/contacts`)
    .then(response => {
      this.context.commit("setContacts", response.data);
      this.setLoadingContacts(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingContacts(false);
    });
  }

  @Action
  async updateContactWorkerIsBlocking(payload: { id: string; isBlocking: boolean }) {
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/contact-workers/${payload.id}/is-blocking`, { isBlocking: payload.isBlocking })
    .then(() => {
      this.getContacts();
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async getJobs() {
    this.setLoadingJobs(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/jobs`)
    .then(response => {
      this.context.commit("setJobs", response.data);
      this.setLoadingJobs(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingJobs(false);
    });
  }

  @Action
  async uploadDocument(fileWithExpiry: FileWithExpiry) {

    const fileExtension = "." + fileWithExpiry.file.name.split('.').pop();
    const contentType = FileUtils.cleanContentType(fileExtension, fileWithExpiry.file.type);
    //First get the signed URL
    const uploadRequest = new UploadDocumentRequest();
    uploadRequest.fileName = fileWithExpiry.file.name;
    uploadRequest.contentType = contentType;
    let destinationFileName = '';

    this.setLoadingDialog(true);
    //this.context.commit("setDocumentUploadUrl", null);
    await ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/documents/upload`, uploadRequest)
    .then(uploadResponse => {
      const config = {
        headers: {
          'content-type': contentType
        }
      };
      destinationFileName = uploadResponse.data.destinationFileName;
      return ajax.put(uploadResponse.data.signedUrl, fileWithExpiry.file, config)})
      .then(googleResponse => {
        const createRequest = new CreateDocumentRequest();
        createRequest.originFileName = fileWithExpiry.file.name;
        createRequest.contentType = contentType;
        createRequest.destinationFileName = destinationFileName;
        createRequest.isExpiryTracked = fileWithExpiry.isExpiryTracked;
        createRequest.expiresAt = fileWithExpiry.expiresAt;
        ajax.post(`/api/v1/agency/workers/${this.currentWorker.id}/documents`, createRequest)
        .then(response => {
          this.context.commit("setDocumentFromUpload", response.data);
          this.setLoadingDialog(false);
        })
      })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  async downloadDocument(id: string) {
    this.setLoadingDialog(true);
    await ajax.get(`/api/v1/agency/workers/${this.currentWorker.id}/documents/${id}`)
    .then(response => {
      //download the file
      const element = document.createElement('a');
      element.setAttribute('href', response.data.signedUrl);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);          
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async editDocument(document: DocumentDto) {
    const request = new UpdateDocumentRequest();
    request.updatedAt = document.updatedAt;
    request.name = document.name;
    request.isExpiryTracked = document.isExpiryTracked;
    if (document.expiresAt !== null) {
      request.expiresAt = new Date(document.expiresAt).toISOString().substr(0, 10)
    } 
    this.setLoadingDialog(true);
    await ajax.put(`/api/v1/agency/workers/${this.currentWorker.id}/documents/${document.id}`, request)
    .then(response => {
      this.context.commit("setDocumentFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  //Messaging related

  @Action
  public async getAgencyUsers() {
    await ajax.get(`/api/v1/agency/users`)
    .then(response => {
      this.context.commit("setAgencyUsers", response.data );
    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  async getConversationTopics() {

      this.context.commit("clearConversationTopics");

      const q = query(collection(db, "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics"), 
      where("isEnabled", "==", true),
      where("isPublic", "==", true), 
      orderBy("name"));

      const unsubscribeToConversationTopicsCallback = onSnapshot(q, (querySnapshot: { docChanges: () => any[] }) => {
          querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; name: string; actionRequiredCount: number; isEnabled: boolean; isPublic: boolean } } }) => {
              if (change.type === "added") {
                  const conversationTopic = new ConversationTopicFirestoreDto();
                  conversationTopic.id = change.doc.id;
                  conversationTopic.name = change.doc.data().name;
                  conversationTopic.actionRequiredCount = change.doc.data().actionRequiredCount;
                  conversationTopic.isEnabled = change.doc.data().isEnabled;
                  conversationTopic.isPublic = change.doc.data().isPublic;
                  this.context.commit("addConversationTopic", conversationTopic);
              }
              if (change.type === "modified") {
                  const conversationTopic = new ConversationTopicFirestoreDto();
                  conversationTopic.id = change.doc.id;
                  conversationTopic.actionRequiredCount = change.doc.data().actionRequiredCount;
                  conversationTopic.isEnabled = change.doc.data().isEnabled;
                  conversationTopic.isPublic = change.doc.data().isPublic;
                  this.context.commit("updateConversationTopic", conversationTopic);
              }
              if (change.type === "removed") {
                const conversationTopicToBeRemovedIndex = this.conversationTopics.findIndex((findConversationTopic: ConversationTopicFirestoreDto) => findConversationTopic.id === change.doc.id);
                if (conversationTopicToBeRemovedIndex != -1) {
                  this.context.commit("removeConversationTopic", conversationTopicToBeRemovedIndex);
                }
              }
          });
      });

      this.context.commit("setUnsubscribeToConversationTopicsCallback", unsubscribeToConversationTopicsCallback);
     // this.setLoadingConversations(false);
  }

  @Action
  async getConversations(pageNumber: number) {

      console.log("Getting Conversations");
      console.log("Clearing conversations first");
      this.context.commit("clearConversations");
      console.log("Total conversations = " + this.conversations.length.toString());

      this.setLoadingConversations(true);
      //this.currentConversationSearchCriteria = new CurrentConversationSearchCriteria();
      this.currentConversationSearchCriteria.selectedAssignedTo = this.filterConversationSearchViewModel.selectedAssignedTo;
      this.currentConversationSearchCriteria.selectedStatus = this.filterConversationSearchViewModel.selectedStatus;

      let q;
      if (this.currentConversationSearchCriteria.selectedStatus !== undefined) {
          if (this.currentConversationSearchCriteria.selectedAssignedTo !== undefined) {
            console.log("Running status defined and assigned to defined query");
              q = query(
                  collectionGroup(db, 
                    "conversations"), 
                    orderBy("lastMessageCreatedAt", "desc"), 
                    where("tenantId", "==", AppModule.currentAgencyContext.id),
                    where("workerFirebaseUserId", "==", this.currentWorker.userId),
                    where("assignedToFirebaseUserId", "==", this.filterConversationSearchViewModel.selectedAssignedTo.userId));
                    where("status", "==", this.filterConversationSearchViewModel.selectedStatus);
          } else {
            console.log("Running status defined and assigned to undefined query");
              q = query(
              collectionGroup(db, 
                "conversations"), 
                orderBy("lastMessageCreatedAt", "desc"), 
                where("tenantId", "==", AppModule.currentAgencyContext.id),
                where("workerFirebaseUserId", "==", this.currentWorker.userId),
                where("status", "==", this.filterConversationSearchViewModel.selectedStatus));
          }
      } else {
          if (this.currentConversationSearchCriteria.selectedAssignedTo !== undefined) {
            console.log("Running status undefined and assigned to defined query");  
            q = query(
                collectionGroup(db, 
                  "conversations"), 
                  orderBy("lastMessageCreatedAt", "desc"), 
                  where("tenantId", "==", AppModule.currentAgencyContext.id),
                  where("workerFirebaseUserId", "==", this.currentWorker.userId),
                  where("assignedToFirebaseUserId", "==", this.filterConversationSearchViewModel.selectedAssignedTo.userId),
                  where("status", "in", [10,20,30,40,50]));  
          } else {
            console.log("Running status undefined and assigned to undefined query");
            q = query(
            collectionGroup(db, 
              "conversations"), 
              orderBy("lastMessageCreatedAt", "desc"),
              where("tenantId", "==", AppModule.currentAgencyContext.id),
              where("workerFirebaseUserId", "==", this.currentWorker.userId),
              where("status", "in", [10,20,30,40,50]));            
        }
     }

      const unsubscribeToConversationsCallback = onSnapshot(q, (querySnapshot: { docChanges: () => any[] }) => {
          querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; branchId: string; deskId: string; locationId: string; locationBrandName: string; companyId: string; companyBrandName: string; departmentId: string; departmentName: string; conversationTopicId: string; conversationTopicType: number; 
              workerId: string; workerFirebaseUserId: string; workerDisplayName: string; workerAvatar: string; assignedToEntityId: string; assignedToEntityType: number; assignedToFirebaseUserId: string; assignedToDisplayName: string; assignedToAvatar: string; bookingId: string; bookingRoleId: string; bookingRoleWorkerId: string; sequenceNumber: string;
              lastMessageCreatedAt: any; lastMessage: MessageDto; conversationTopicName: string;
              participantFirebaseUserIds: string[]; status: number; subject: string; }; }; }) => {
              if (change.type === "added") {
                  const conversation = new ConversationDto();
                  conversation.id = change.doc.id;
                  conversation.branchId = change.doc.data().branchId;
                  conversation.deskId = change.doc.data().deskId;
                  conversation.bookingId = change.doc.data().bookingId;
                  conversation.bookingRoleId = change.doc.data().bookingRoleId;
                  conversation.bookingRoleWorkerId = change.doc.data().bookingRoleWorkerId;
                  conversation.companyId = change.doc.data().companyId;
                  conversation.companyBrandName = change.doc.data().companyBrandName;
                  conversation.locationId = change.doc.data().locationId;
                  conversation.locationBrandName = change.doc.data().locationBrandName;
                  conversation.departmentId = change.doc.data().departmentId;
                  conversation.departmentName = change.doc.data().departmentName;
                  conversation.workerFirebaseUserId = change.doc.data().workerFirebaseUserId;
                  conversation.workerAvatar = change.doc.data().workerAvatar;
                  conversation.workerDisplayName = change.doc.data().workerDisplayName;
                  conversation.workerId = change.doc.data().workerId;
                  conversation.assignedToEntityId = change.doc.data().assignedToEntityId;
                  conversation.assignedToEntityType = change.doc.data().assignedToEntityType;
                  conversation.assignedToFirebaseUserId = change.doc.data().assignedToFirebaseUserId;
                  conversation.assignedToDisplayName = change.doc.data().assignedToDisplayName;
                  conversation.assignedToAvatar = change.doc.data().assignedToAvatar;
                  conversation.participantFirebaseUserIds = change.doc.data().participantFirebaseUserIds;
                  conversation.subject = change.doc.data().subject;
                  conversation.status = change.doc.data().status;
                  conversation.sequenceNumber = change.doc.data().sequenceNumber;
                  conversation.conversationTopicId = change.doc.data().conversationTopicId;
                  conversation.conversationTopicType = change.doc.data().conversationTopicType;
                  conversation.conversationTopicName = change.doc.data().conversationTopicName;
                  conversation.lastMessageCreatedAt = change.doc.data().lastMessageCreatedAt.toDate();
                  conversation.lastMessage = change.doc.data().lastMessage;

                  if (this.conversations.length === 0) {
                    //First conversation in the list
                    this.context.commit("addConversation", conversation);
                  } else if (conversation.lastMessageCreatedAt > this.conversations[0].lastMessageCreatedAt) {
                    //A new conversation has been added after the initial set has been loaded
                    //We don't add one here as it disrupts the selected conversation and the user 
                    //could be typing a message 
                    this.context.commit("setShowNewConversationBanner", true);
                  } else {
                    //Conversation is older than the first in the list - add it to the end
                    this.context.commit("addConversation", conversation);
                  }
                  if (!this.workerConversationsVM.selectedConversation) {
                      this.updateSelectedConversation(conversation.id);
                  }
              }
              if (change.type === "modified") {
                  const existingConversationIndex = this.conversations.findIndex((findConversation: ConversationDto) => findConversation.id === change.doc.id);
                  if (existingConversationIndex != -1) {
                      this.conversations[existingConversationIndex].status = change.doc.data().status;
                      this.conversations[existingConversationIndex].conversationTopicName = change.doc.data().conversationTopicName;
                      this.conversations[existingConversationIndex].assignedToDisplayName = change.doc.data().assignedToDisplayName;
                      this.conversations[existingConversationIndex].assignedToAvatar = change.doc.data().assignedToAvatar;
                      this.conversations[existingConversationIndex].assignedToEntityId = change.doc.data().assignedToEntityId;
                      this.conversations[existingConversationIndex].assignedToEntityType = change.doc.data().assignedToEntityType;
                      this.conversations[existingConversationIndex].participantFirebaseUserIds = change.doc.data().participantFirebaseUserIds;
                      this.conversations[existingConversationIndex].lastMessageCreatedAt = change.doc.data().lastMessageCreatedAt.toDate();
                      this.conversations[existingConversationIndex].lastMessage = change.doc.data().lastMessage;
                  }
              }
              if (change.type === "removed") {
                  const conversationToBeRemovedIndex = this.conversations.findIndex((findConversation: ConversationDto) => findConversation.id === change.doc.id);
                  if (conversationToBeRemovedIndex != -1) {
                      this.context.commit("removeConversation", conversationToBeRemovedIndex);
                      this.context.commit("clearMessages");
                      this.context.commit("clearConversationParticipants");
                  }
                  //If it was the last one in the list and there are still conversations left
                  //select the one above it
                  if (this.conversations.length > 0) {
                      if (this.conversations.length === conversationToBeRemovedIndex) {
                          //It was the last one in the index
                          //Select the one above it
                          this.updateSelectedConversation(this.conversations[conversationToBeRemovedIndex -1].id);
                      } else {
                          //It wasn't the last one - replace with the one that took its place
                          this.updateSelectedConversation(this.conversations[conversationToBeRemovedIndex].id);
                      }
                      
                  }
              }
          });
      });
      this.context.commit("setUnsubscribeToConversationsCallback", unsubscribeToConversationsCallback);
      this.setLoadingConversations(false);
  }

  @Action
  public async updateSelectedConversation(id: string){
    const conversation = this.conversations.find((findConversation => id === findConversation.id));
    if (!conversation) {
      this.context.commit("setSelectedConversation", null);
      return;
    }

    this.context.commit("setBookingRoleWorkerSummary", null);    
    this.context.commit("setSelectedConversation", conversation);
    this.setLoadingConversation(true);
    
    const messagesQuery = query(
        collection(db, 
            "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + conversation.conversationTopicId + "/conversations/" + this.workerConversationsVM.selectedConversation.id + "/conversationMessages"), orderBy("createdAt"));

    const unsubscribeToMessagesCallback = onSnapshot(messagesQuery, (querySnapshot: { docChanges: () => any[] }) => {
        querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; createdAt: any; firebaseUserId: string; body: string; hasWorkerRead: boolean; type: number} } }) => {
            const msg = new MessageDto();
            msg.id = change.doc.id;
            msg.body = change.doc.data().body;
            msg.firebaseUserId = change.doc.data().firebaseUserId;
            msg.type = change.doc.data().type;
            msg.createdAt = change.doc.data().createdAt.toDate();
            msg.hasWorkerRead = change.doc.data().hasWorkerRead;
            if (change.type === "added") {
                this.context.commit("addMessage", msg);
            }
            if (change.type === "modified") {
                this.context.commit("updateMessage", msg);
            }
            if (change.type === "removed") {
            }
        });
    });
    this.context.commit("setUnsubscribeToMessagesCallback", unsubscribeToMessagesCallback);

    const conversationParticipantsQuery = query(
        collection(db, 
            "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + conversation.conversationTopicId + "/conversations/" + this.workerConversationsVM.selectedConversation.id + "/conversationParticipants"), orderBy("displayName"));

    const unsubscribeToConversationParticipantsCallback = onSnapshot(conversationParticipantsQuery, (querySnapshot: { docChanges: () => any[] }) => {
        querySnapshot.docChanges().forEach((change: { type: string; doc: { id: string; data: () => { (): any; new(): any; displayName: string; entityId: string; avatar: string; entityType: EntityType} } }) => {
            if (change.type === "added") {
                const conversationParticipant = new ConversationParticipantDto();
                conversationParticipant.id = change.doc.id;
                conversationParticipant.avatar = change.doc.data().avatar;
                conversationParticipant.entityType = change.doc.data().entityType as EntityType;
                conversationParticipant.entityId = change.doc.data().entityId;
                conversationParticipant.displayName = change.doc.data().displayName;
                this.context.commit("addConversationParticipant", conversationParticipant);
            }
            if (change.type === "modified") {
            }
            if (change.type === "removed") {
            }
        });
        
    });
    this.context.commit("setUnsubscribeToConversationParticipantsCallback", unsubscribeToConversationParticipantsCallback);

    this.setLoadingConversation(false);
    
  }

  @Action
  public async sendMessage(message: string){
      // const newMessage = new MessageDto();
      // newMessage.createdAt = new Date();
      // newMessage.createdByDisplayName = AppModule.currentUser.displayName;
      // newMessage.createdByFirebaseUserId = AppModule.currentUser.uid;
      // newMessage.createdByEntityType = EntityType.AgencyUser;
      // newMessage.body = message;
      const newMessage = {
          "createdAt": new Date(),
          "tenantId": AppModule.currentAgencyContext.id,
          "firebaseUserId": AppModule.currentUser.uid,
          "hasWorkerRead" : false,
          "type": 1,
          "body": message
      }

      await addDoc(collection(db, "tenants/" + AppModule.currentAgencyContext.id + "/conversationTopics/" + this.workerConversationsVM.selectedConversation.conversationTopicId + "/conversations/" + this.workerConversationsVM.selectedConversation.id + "/conversationMessages"), newMessage);
  }

  @Action
  public async assignConversation(request: AssignConversationRequest) {
    await ajax.put(`/api/v1/agency/conversation-topics/${this.workerConversationsVM.selectedConversation.conversationTopicId}/conversations/${this.workerConversationsVM.selectedConversation.id}/assigned-to`, request)
    .then(response => {

    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  public async editConversationStatus(request: UpdateConversationStatusRequest) {
    await ajax.put(`/api/v1/agency/conversation-topics/${this.workerConversationsVM.selectedConversation.conversationTopicId}/conversations/${this.workerConversationsVM.selectedConversation.id}/status`, request)
    .then(response => {

    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  public async createConversationParticipant(request: CreateConversationParticipantRequest) {
    await ajax.post(`/api/v1/agency/conversation-topics/${this.workerConversationsVM.selectedConversation.conversationTopicId}/conversations/${this.workerConversationsVM.selectedConversation.id}/participants`, request)
    .then(response => {

    })
    .catch(error => {
      AppModule.handleApiError(error);
    });
  }

  @Action
  public async getBookingRoleWorkerSummary(id: string) {
    this.setLoadingBookingRoleWorkerSummary(true); 
    //This is silly - we aren't checking the booking or booking role ID so it stil works
    await ajax.get(`/api/v1/agency/bookings/null-id/roles/null-id/workers/${id}`)
    .then(response => {
      this.context.commit("setBookingRoleWorkerSummary", response.data);
      this.setLoadingBookingRoleWorkerSummary(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingBookingRoleWorkerSummary(false);
    })
  }

  @Action
  public async createConversation(request: CreateConversationRequest) {
    this.setLoadingDialog(true); 
    request.workerId = this.currentWorker.id;
    const conversationTopicId = request.conversationTopicId;
    request.conversationTopicId = undefined;
    await ajax.post(`/api/v1/agency/conversation-topics/${conversationTopicId}/conversations`, request)
    .then(response => {
      this.setLoadingDialog(false); 
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false); 
    });
  }

  @Mutation
  resetState() {
    this.agencyAttributes = new AgencyAttributesDto();
    this.currentWorker = new WorkerDto();  
    this.currentPosition = new WorkerPositionDto();  
    this.currentSkill = new WorkerSkillDto(); 
    this.currentQualification = new WorkerQualificationDto();      
    this.positions = [];
    this.skills = [];
    this.qualifications = [];
    this.notes = [];
    this.noteCategories = [];
    this.locationWorkers =[];
    this.locations = [];
    this.documents = [];
    this.shifts = [];
    this.contacts = [];
    this.jobs = [];
    this.awrSummary = [];
  
    this.loading = true;
    this.loadingPositions = true;
    this.loadingSkills = true;
    this.loadingQualifications = true;
    this.loadingNotes = true;
    this.loadingLocationWorkers = true;
    this.loadingLocations = true;
    this.loadingDocuments = true;
    this.loadingShifts = true;
    this.loadingContacts = true;
    this.loadingAwrSummary = true;
    this.loadingDialog = false;

    //Messaging related
    this.loadingConversations = true;
    this.loadingConversation = false;
    this.loadingWorkerProfile = false;
    this.loadingBookingRoleWorkerSummary = false;
    this.filterConversationSearchViewModel = new FilterConversationSearchViewModel();
    //this.selectedConversation = null;
    //this.selectedConversationId = '';
    this.conversationTopics = [];
    this.conversations = [];
    if (this.unsubscribeToConversationTopics) {
        this.unsubscribeToConversationTopics();
        //this.unsubscribeToConversations = null;
    }
    if (this.unsubscribeToConversations) {
        this.unsubscribeToConversations();
        //this.unsubscribeToConversations = null;
    }
    this.messages = [];
    if (this.unsubscribeToMessages) {
        this.unsubscribeToMessages();
        //this.unsubscribeToMessages = null;
    }
    this.conversationParticipants = [];
    if (this.unsubscribeToConversationParticipants) {
        this.unsubscribeToConversationParticipants();
    }
    this.agencyUsers = [];
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoading: boolean) {
      this.loadingDialog = isLoading;
  }
  
  @Mutation
  private async setAgencyAttributes(attributes: AgencyAttributesDto) {
      this.agencyAttributes = attributes;
  }

  @Mutation
  private async setCurrentWorker(worker: WorkerDto) {
      //Make sure the availability isn't a null array
      if (worker.availability === null) {
        worker.availability = [];
      }
      if (worker.workTypes === null) {
        worker.workTypes = [];
      }
      this.currentWorker = worker;
  }

  @Mutation
  private async setAvailabilityRestrictionPeriodFromCreate(period: AvailabilityRestrictionPeriodDto) {
    this.currentWorker.availabilityRestrictionPeriods.push(period);
  }

  @Mutation 
  private async removeAvailabilityRestrictionPeriodFromDelete(period: AvailabilityRestrictionPeriodDto) {
    const index = this.currentWorker.availabilityRestrictionPeriods.findIndex((findPeriod: AvailabilityRestrictionPeriodDto) => findPeriod.id === period.id)
    this.currentWorker.availabilityRestrictionPeriods.splice(index, 1);
  }

  @Mutation
  private async setPositions(positions: WorkerPositionDto[]) {
      this.positions = positions;
  }


  @Mutation
  private async setPositionFromCreate(workerPosition: WorkerPositionDto) {
      this.positions.push(workerPosition);
  }

  @Mutation
  private async setPositionFromEdit(workerPosition: WorkerPositionDto) {
      const index = WorkerDetailsModule.positions.findIndex((findWorkerPosition: WorkerPositionDto) => findWorkerPosition.id === workerPosition.id)
      WorkerDetailsModule.positions.splice(index, 1, workerPosition);
  }

  @Mutation
  private async removePosition(workerPositionId: string) {
      const index = WorkerDetailsModule.positions.findIndex((findWorkerPosition: WorkerPositionDto) => findWorkerPosition.id === workerPositionId)
      if (index !== -1) {
        WorkerDetailsModule.positions.splice(index, 1);
      }
  }

  @Mutation
  private async setLoadingPositions(isLoading: boolean) {
      this.loadingPositions = isLoading;
  }

  @Mutation
  private async setLoadingLocationWorkers(isLoading: boolean) {
      this.loadingLocationWorkers = isLoading;
  }

  @Mutation
  private async setLocationWorkers(locationWorkers: LocationWorkerDto[]) {
      this.locationWorkers = locationWorkers;
  }

  @Mutation
  private async setLocationWorkerFromCreate(locationWorker: LocationWorkerDto) {
      this.locationWorkers.unshift(locationWorker);
  }

  @Mutation
  private async setLocationWorkerFromDelete(locationWorkerId: string) {
    const index = this.locationWorkers.findIndex((findWorker: LocationWorkerDto) => locationWorkerId === findWorker.id);
    this.locationWorkers.splice(index,1);
  }

  @Mutation
  private async setLocationWorkerFromEdit(locationWorker: LocationWorkerDto) {
    const index = this.locationWorkers.findIndex((findWorker: LocationWorkerDto) => locationWorker.id === findWorker.id);
  this.locationWorkers.splice(index, 1, locationWorker);
  }

  @Mutation
  private async setSkills(skills: WorkerSkillDto[]) {
      this.skills = skills;
  }

  @Mutation
  private async setSkillFromCreate(workerSkill: WorkerSkillDto) {
      this.skills.push(workerSkill);
  }

  @Mutation
  private async setSkillFromEdit(workerSkill: WorkerSkillDto) {
      const index = WorkerDetailsModule.skills.findIndex((findWorkerSkill: WorkerSkillDto) => findWorkerSkill.id === workerSkill.id)
      WorkerDetailsModule.skills.splice(index, 1, workerSkill);

  }

  @Mutation
  private async removeSkill(workerSkillId: string) {
      const index = WorkerDetailsModule.skills.findIndex((findWorkerSkill: WorkerSkillDto) => findWorkerSkill.id === workerSkillId)
      if (index !== -1) {
        WorkerDetailsModule.skills.splice(index, 1);
      }
  }

  @Mutation
  private async setLoadingSkills(isLoading: boolean) {
      this.loadingSkills = isLoading;
  }

  @Mutation
  private async setQualifications(qualifications: WorkerQualificationDto[]) {
      this.qualifications = qualifications;
  }

  @Mutation
  private async setQualificationFromCreate(workerQalification: WorkerQualificationDto) {
      this.qualifications.push(workerQalification);
  }

  @Mutation
  private async setQualificationFromEdit(workerQualification: WorkerQualificationDto) {
      const index = WorkerDetailsModule.qualifications.findIndex((findWorkerQualification: WorkerQualificationDto) => findWorkerQualification.id === workerQualification.id)
      WorkerDetailsModule.qualifications.splice(index, 1, workerQualification);
  }

  @Mutation
  private async removeQualification(workerQualificationId: string) {
      const index = WorkerDetailsModule.qualifications.findIndex((findWorkerQualification: WorkerQualificationDto) => findWorkerQualification.id === workerQualificationId)
      if (index !== -1) {
        WorkerDetailsModule.qualifications.splice(index, 1);
      }
  }

  @Mutation
  private async setLoadingQualifications(isLoading: boolean) {
      this.loadingQualifications = isLoading;
  }

  @Mutation
  private async setLocations(locations: LocationProfileDto[]) {
      this.locations = locations;
  }

  @Mutation
  private async setNoteCategories(noteCategories: NoteCategoryDto[]) {
      this.noteCategories = noteCategories;
  }

  @Mutation
  private async setNotes(notes: NoteDto[]) {
      this.notes = notes;
  }

  @Mutation
  private async setNoteFromCreate(note: NoteDto) {
      this.notes.unshift(note);
  }

  @Mutation
  private async setNoteFromEdit(note: NoteDto) {
      const index = this.notes.findIndex((findNote: NoteDto) => findNote.id === note.id)
      this.notes.splice(index, 1, note);
  }

  @Mutation
  private async setLoadingNotes(isLoading: boolean) {
      this.loadingNotes = isLoading;
  }

  @Mutation
  private async setDocuments(documents: DocumentDto[]) {
      this.documents = documents;
  }

  @Mutation
  private async setShifts(shifts: TimesheetDto[]) {
      this.shifts = shifts;
  }

  @Mutation
  private async setContacts(contacts: ContactWorkerDto[]) {
      this.contacts = contacts;
  }

  @Mutation
  private async setJobs(jobs: JobWorkerDto[]) {
      this.jobs = jobs;
  }

  @Mutation
  private async setAwrSummary(awrSummary: AgencyWorkerRightsCalendar[]) {
      this.awrSummary = awrSummary;
  }

  @Mutation
  private async setDocumentFromUpload(document: DocumentDto) {
      this.documents.push(document);
  }

  @Mutation
  private async setDocumentFromEdit(document: DocumentDto) {
      const index = this.documents.findIndex((findDocument: DocumentDto) => findDocument.id === document.id)
      this.documents.splice(index, 1, document);
  }

  @Mutation
  private async setLoadingDocuments(isLoading: boolean) {
      this.loadingDocuments = isLoading;
  }

  @Mutation
  private async setLoadingShifts(isLoading: boolean) {
      this.loadingShifts = isLoading;
  }

  @Mutation
  private async setLoadingContacts(isLoading: boolean) {
      this.loadingContacts = isLoading;
  }

  @Mutation
  private async setLoadingJobs(isLoading: boolean) {
      this.loadingJobs = isLoading;
  }

  @Mutation
  private async setLoadingAwrSummary(isLoading: boolean) {
      this.loadingAwrSummary = isLoading;
  }

  @Mutation
  private async setLoadingBookingRoleWorkerSummary(loading: boolean) {
      this.loadingBookingRoleWorkerSummary = loading;
  }

  @Mutation
  private async setLoadingConversations(loading: boolean) {
      this.loadingConversations = loading;
  }

  @Mutation
  private async setLoadingConversation(loading: boolean) {
      this.loadingConversation = loading;
  }

  @Mutation
  private async setShowNewConversationBanner(show: boolean) {
      this.showNewConversationBanner = show;
  }

  @Mutation
  private clearConversations() {
      if (this.unsubscribeToConversations != null) {
          this.unsubscribeToConversations();
          this.unsubscribeToConversations = null;
      }
      this.conversations = [];
      this.workerConversationsVM.selectedConversation = null;
      if (this.unsubscribeToMessages != null) {
          this.unsubscribeToMessages();
          this.unsubscribeToMessages = null;
      }
      this.messages = [];
      if (this.unsubscribeToConversationParticipants != null) {
          this.unsubscribeToConversationParticipants();
      }
      this.conversationParticipants = [];
      this.bookingRoleWorkerSummary = null;
      this.showNewConversationBanner = false;
  }

  @Mutation
  private async clearConversationTopics() {
      this.conversationTopics = [];
      if (this.unsubscribeToConversationTopics != null) {
          this.unsubscribeToConversationTopics();
          this.unsubscribeToConversationTopics = null;
      }
      this.workerConversationsVM.selectedConversation = null;
      this.workerConversationsVM.selectedConversationId = '';
  }

  @Mutation
  private async addConversationTopic(conversationTopic: ConversationTopicFirestoreDto) {
      this.conversationTopics.push(conversationTopic);
  }

  @Mutation
  private async updateConversationTopic(conversationTopic: ConversationTopicFirestoreDto) {
    const foundConversationTopic = this.conversationTopics.find((findConversationTopic: ConversationTopicFirestoreDto) => findConversationTopic.id === conversationTopic.id);
    if (foundConversationTopic != null) {
        foundConversationTopic.name = conversationTopic.name;
    } 
  }

  @Mutation
  private async removeConversationTopic(conversationTopicIndex: number) {
      const conversationTopicByIndex = this.conversationTopics[conversationTopicIndex];
      if (conversationTopicByIndex) {
        const deleted = this.conversations.splice(conversationTopicIndex, 1);
      }
  }

  @Mutation
  private async addConversation(conversation: ConversationDto) {
      this.conversations.push(conversation);
  } 
    
  @Mutation
  private async removeConversation(conversationIndex: number) {
      const conversationByIndex = this.conversations[conversationIndex];
      if (conversationByIndex && this.workerConversationsVM.selectedConversation) {
          if (conversationByIndex.id == this.workerConversationsVM.selectedConversation.id) {
              this.workerConversationsVM.selectedConversation = null;
              this.workerConversationsVM.selectedConversationId = '';
          }
      }
      const deleted = this.conversations.splice(conversationIndex, 1);
  }

  @Mutation
  private async setSelectedConversation(conversation: ConversationDto) {
      if (this.unsubscribeToMessages != null) {
          this.unsubscribeToMessages();
      }
      this.messages = [];
      if (this.unsubscribeToConversationParticipants != null) {
          this.unsubscribeToConversationParticipants();
      }
      this.conversationParticipants = [];
      this.workerConversationsVM.selectedConversation = conversation;
      if (this.workerConversationsVM.selectedConversation) {
        this.workerConversationsVM.selectedConversationId = conversation.id;
      } else {
        this.workerConversationsVM.selectedConversationId = '';
      }
      
  }

  @Mutation
  private async setBookingRoleWorkerSummary(brw: BookingRoleWorkerDto) {
      this.bookingRoleWorkerSummary = brw;
  }

  @Mutation
  private async setMessages(messages: MessageDto[]) {
      this.messages = messages;
  }

  @Mutation
  private async addMessage(message: MessageDto) {
      this.messages.push(message);
  }

  @Mutation
  private async updateMessage(message: MessageDto) {
      const foundMessage = this.messages.find((findMessage: MessageDto) => findMessage.id === message.id);
      if (foundMessage != null) {
          foundMessage.hasWorkerRead = message.hasWorkerRead;
      }
  }

  @Mutation
  private async clearMessages() {
      this.messages = [];
      if (this.unsubscribeToMessages != null) {
          this.unsubscribeToMessages();
      }
  }

  @Mutation
  private async setAgencyUsers(agencyUsers: AgencyUserDto[]) {
      this.agencyUsers = agencyUsers;
  }

  @Mutation
  private async setConversationParticipants(conversationParticipants: ConversationParticipantDto[]) {
      this.conversationParticipants = conversationParticipants;
  }

  @Mutation
  private async addConversationParticipant(conversationParticipant: ConversationParticipantDto) {
      this.conversationParticipants.push(conversationParticipant);
  }

  @Mutation
  private async clearConversationParticipants() {
      this.conversationParticipants = [];
      if (this.unsubscribeToConversationParticipants != null) {
          this.unsubscribeToConversationParticipants();
      }
  }

  @Mutation
  private async setUnsubscribeToConversationTopicsCallback(callback: any) {
      this.unsubscribeToConversationTopics = callback;
  }

  @Mutation
  private async setUnsubscribeToConversationsCallback(callback: any) {
      this.unsubscribeToConversations = callback;
  }

  @Mutation
  private async setUnsubscribeToMessagesCallback(callback: any) {
      this.unsubscribeToMessages = callback;
  }

  @Mutation
  private async setUnsubscribeToConversationParticipantsCallback(callback: any) {
      this.unsubscribeToConversationParticipants = callback;
  }
}


export const WorkerDetailsModule = getModule(WorkerDetails)
